import { render, staticRenderFns } from "./asyncChat.vue?vue&type=template&id=e2b1c08c&"
import script from "./asyncChat.vue?vue&type=script&lang=js&"
export * from "./asyncChat.vue?vue&type=script&lang=js&"
import style0 from "./asyncChat.vue?vue&type=style&index=0&id=e2b1c08c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports